import { useAtticLotDetailsQuery } from "@dashboard/graphql";
import { Box, Skeleton, Text } from "@saleor/macaw-ui-next";
import { useIntl } from "react-intl";

import AtticLotDetailsPage from "../components/AtticLotDetailsPage/AtticLotDetailsPage";
import { lotMessages } from "../messages";

export const AtticLotDetailsView = ({ id }: { id: string }) => {
  const intl = useIntl();
  const { data, loading } = useAtticLotDetailsQuery({ displayLoader: true, variables: { id } });
  const lot = data?.atticLot;

  if (loading && !data) {
    return (
      <Box padding={6}>
        <Skeleton />
      </Box>
    );
  }

  if (!lot) {
    return (
      <Box padding={6}>
        <Text size={4} data-test-id="attic-lot-missing">
          {intl.formatMessage(lotMessages.notFound)}
        </Text>
      </Box>
    );
  }

  return <AtticLotDetailsPage lot={lot} />;
};

export default AtticLotDetailsView;
